var map = {
	"./instagramestory1-1.jpg": "b6a1",
	"./instagramestory1.jpg": "4d02",
	"./instagramestory10.jpg": "0928",
	"./instagramestory2-1.jpg": "b594",
	"./instagramestory2.jpg": "0168",
	"./instagramestory3-1.jpg": "6e0c",
	"./instagramestory3.jpg": "7b77",
	"./instagramestory4-1.jpg": "c2fa",
	"./instagramestory4.jpg": "fe09",
	"./instagramestory5-1.jpg": "cd84",
	"./instagramestory5.jpg": "063c",
	"./instagramestory6-1.jpg": "169e",
	"./instagramestory6.jpg": "66ae",
	"./instagramestory7.jpg": "2a0b",
	"./instagramestory8.jpg": "ccc1",
	"./instagramestory9.jpg": "c22c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4d8f";